import StudentOnlineHomework from './model';
import create from './create';

StudentOnlineHomework.create = create;

export default StudentOnlineHomework;



// WEBPACK FOOTER //
// ./data/OnlineHomework/StudentOnlineHomework/index.js